<template>
  <div class="redirect">
    <div class="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading">
      <div class="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>

  import authenService from "../../services/authenService";
  import deviceInfoService from "../../services/deviceInfoService";
  import VueCookies from 'vue-cookies';
  import fcmService from "../../services/fcmService";

  export default {

    name: "LogoutCallback",

    created() {
      const localToken = fcmService.getFromLocalStorage();
      if (!localToken) {
        this.removeDeviceInfo();
        this.removeToken();
      }
      else {
        this.unSubscribeFcm(localToken).then(() => {
          fcmService.removeDeviceToken();
          this.removeDeviceInfo();
          this.removeToken();
        });
      }
    },

    methods: {
      unSubscribeFcm(localToken) {
          return fcmService.clearSessionToken(localToken)
      },
      removeDeviceInfo() {
        deviceInfoService.removeDeviceInfo();
      },
      removeToken() {
        authenService
          .removeToken()
          .then(() => {
            VueCookies.remove("IdHash");
            this.$router.replace({name: 'login'});
          });
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/LogoutCallback.vue